import api from './api';
import { sessionReplayEvent } from '../config/sessionReplayInit';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const pagesService = {
  // Retorna todas as páginas do usuário
  async getAll() {
    const response = await api.get('/pages');
    return extractData(response.data);
  },

  // Buscar página por ID
  async getById(id) {
    const response = await api.get(`/pages/${id}`);
    return response.data;
  },

  // Criar nova página (legado — link_in_bio v1, company, professional)
  async create(data) {
    const response = await api.post('/pages', data);
    return response.data;
  },

  // Criar nova página site (link_in_bio v2, professional, company)
  // Espera { type: PageType (int enum), title, slug, templateId: TemplateId (int enum), draftConfig: SiteConfigDto }
  async createSite(data) {
    const response = await api.post('/pages/create-site', data);
    return response.data;
  },

  // Verifica se um slug está livre; se ocupado, o back devolve uma sugestão livre.
  // Retorna { available: bool, suggestion: string|null }. Usado antes do createSite p/ evitar 409.
  async checkSlugAvailable(slug) {
    const response = await api.get('/pages/slug-available', { params: { slug } });
    return response.data;
  },

  // Atualizar página (legado — manter por compatibilidade externa)
  async update(id, data) {
    const response = await api.put(`/pages/${id}`, data);
    return response.data;
  },

  // Salvar rascunho de página (novo ciclo draft/published)
  async updateDraft(id, draftConfig) {
    const response = await api.put(`/pages/${id}/draft`, draftConfig);
    return response.data;
  },

  // Publicar página (soft delete com PublishedAt)
  async publish(id) {
    const response = await api.post(`/pages/${id}/publish`);
    sessionReplayEvent('page_published', { pageId: String(id) });
    return response.data;
  },

  // Despublicar página
  async unpublish(id) {
    const response = await api.post(`/pages/${id}/unpublish`);
    return response.data;
  },

  // Deletar página (soft delete)
  async delete(id) {
    await api.delete(`/pages/${id}`);
  },

  // Obter templates disponíveis para um tipo de página
  async getTemplates(type = 'link-in-bio') {
    const response = await api.get(`/pages/templates/${type}`);
    return response.data;
  },

  // Obter tipos de página disponíveis para seleção no modal
  async getPageTypes() {
    const response = await api.get('/pages/templates/types');
    return response.data;
  },

  // Obter preset de conteúdo pré-populado para um tipo de página
  // @param {string} type - Tipo de página (link_in_bio, company, professional)
  // @returns {Promise<SiteConfigDto>} SiteConfigDto com blocos e estilos pré-populados
  async getPreset(type) {
    const response = await api.get('/pages/preset', { params: { type } });
    return response.data;
  },
};

export default pagesService;
